import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { WIDGET_SIZES } from '@liveHelper/components/shared/WidgetContainer/WidgetContainer.styles'
import type { WidgetState } from '@liveHelper/models/fsm/machine'
import {
  FadeInNoDelayAnimation,
  FlexCenter,
  Transition,
} from '@oneToOne/shared/styles'

import { UnstyledButton } from '@core/components/twind/Button'

export const DialingContainer = styled(UnstyledButton, {
  shouldForwardProp: (prop) =>
    prop !== 'topLevelUIState' && prop !== 'isMobileWeb',
})<{
  topLevelUIState: WidgetState
  isMobileWeb: boolean
}>`
  ${Transition}
  ${FlexCenter}
  position: relative;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;
  background: var(--gray-10) !important;
  width: 100%;
  cursor: pointer;
  ${({ topLevelUIState }) =>
    topLevelUIState === 'minimized'
      ? 'border-radius: var(--border-radius-md)'
      : ''};

  ${({ isMobileWeb, topLevelUIState }) =>
    !isMobileWeb &&
    css`
      min-width: ${
        topLevelUIState === 'minimized'
          ? WIDGET_SIZES.minimized.default.width
          : WIDGET_SIZES.expanded.default.width
      };
      max-height: 100vh;
      max-width: 100vw;
    `}/* Because of the animation to grow the chat container, we need to set a min-width to prevent the chat from shrinking to 0 width when the chat is minimized.
  The reason for this, is longer messages look very awkward when growing from a more minimized state to the chatting default width and height. */
`

export const TopSection = styled.div<{ isMobileWeb: boolean }>`
  ${FadeInNoDelayAnimation}
  display: flex;
  flex-direction: column;

  ${({ isMobileWeb }) =>
    !isMobileWeb &&
    css`
      @media screen and (max-height: 800px) {
        transform: scale(0.9);
        margin-top: 38px;
        overflow-y: auto;
      }

      @media screen and (max-height: 300px) {
        transform: scale(0.8);
        margin-top: 28px;
        overflow-y: auto;
      }
    `}
`

export const DialingText = styled.span`
  color: var(--white);
  font-weight: var(--font-semibold);
  text-align: center;
  padding: 0 var(--spacing-12);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`
